@if(canDisplayFilter){
<div
  class="flex gap-2 mt-5 w-full"
  [class.soft]="softColor()"
  [class.disabled]="disabled()"
>
  @if(showYearPicker()){
  <div class="relative flex-1 min-w-0">
    <label class="filter-label">
      {{ DashboardTranslateKeys.YEAR | translate }}
    </label>
    <p-datepicker
      view="year"
      dateFormat="yy"
      [appendTo]="'body'"
      [panelStyleClass]="'datepicker-overlay'"
      [placeholder]="DashboardTranslateKeys.YEAR | translate"
      [readonlyInput]="true"
      [showClear]="true"
      [showIcon]="true"
      icon="pi pi-chevron-down"
      [(ngModel)]="yearSelected"
      (ngModelChange)="onYearChange()"
    />
  </div>
  } @if(showMonthYearPicker()){
  <div class="relative flex-1 min-w-0">
    <label class="filter-label">
      {{ DashboardTranslateKeys.M_YEAR | translate }}
    </label>
    <p-datepicker
      view="month"
      dateFormat="mm-yy"
      [appendTo]="'body'"
      [panelStyleClass]="'datepicker-overlay'"
      [placeholder]="DashboardTranslateKeys.M_YEAR | translate"
      [readonlyInput]="true"
      [showClear]="true"
      [showIcon]="true"
      icon="pi pi-chevron-down"
      [(ngModel)]="monthYearSelected"
      (ngModelChange)="onMonthYearChange()"
    />
  </div>
  } @if(firstSelectOptions().length) {
  <div class="relative flex-1 min-w-0">
    <label class="filter-label">
      {{ firstSelectOptions()[0]?.label }}
    </label>
    <p-select
      appendTo="body"
      styleClass="dashboard-filter"
      optionLabel="label"
      optionValue="value"
      [options]="firstSelectOptions()"
      (onChange)="onFirstSelectChanged($event)"
    />
  </div>
  } @if(secondSelectOptions().length){
  <div class="relative flex-1 min-w-0">
    <label class="filter-label">
      {{ secondSelectOptions()[0]?.label }}
    </label>
    <p-select
      appendTo="body"
      styleClass="dashboard-filter"
      optionLabel="label"
      optionValue="value"
      [options]="secondSelectOptions()"
      (onChange)="onSecondSelectChanged($event)"
    />
  </div>
  }
</div>
}
